import { Component } from '@angular/core';

@Component({
  selector: 'app-service-information-mapa-container',
  templateUrl: './mapaContainer.component.html',
  styleUrls: ['../service-information.component.css']
})

export class MapaContainerComponent {
  // Contenedor vacio
}



// WEBPACK FOOTER //
// ./src/app/mapaContainer/mapaContainer.component.ts